module.exports = __webpack_public_path__ + "static/img/06@2x.3d67bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/06@2x.png
// module id = qxS4
// module chunks = 1